<template>
  <div class="pagination">
    <button @click="previousPage" :disabled="currentPage === 1">
      <i class="bi bi-chevron-left"></i>
    </button>
    <span v-for="page in visiblePages" :key="page" @click="goToPage(page)" :class="{ active: currentPage === page }">
      {{ page }}
    </span>
    <span v-if="hasMoreItems" @click="fetchMoreOrders">...</span>
    <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages && !hasMoreItems">
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PaginationPage',
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    visiblePages: {
      type: Array,
      required: true,
    },
    hasMoreItems: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['goToPage', 'updatePage'],
  methods: {
    previousPage() {
      if (this.currentPage > 1) {
        this.$emit('updatePage', this.currentPage - 1);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit('updatePage', this.currentPage + 1);
      }
    },
    goToPage(page) {
      this.$emit('goToPage', page);
    },
  },
};
</script>

<style scoped>
.pagination {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  button:disabled i {
    color: #606060;
  }

  span {
    display: inline-block;
    margin: 0 5px;
    padding: 5px 5px 6px;
    cursor: pointer;

    &:hover {
      color: #ad6dc3;
    }
  }

  span.active,
  i:hover {
    color: #e79fff;
  }
}
@media (max-width: 576px) {
  .pagination {
    span {
      font-size: 16px;
    }
  }
}
</style>
